module.exports = __webpack_public_path__ + "img/img_left_nav_person.0e0eba24.svg";